import createGetFormValues from './selectors/getFormValues';
import plain from './structure/plain';

export default createGetFormValues(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/getFormValues.js
// module id = 834
// module chunks = 58